__turbopack_context__.v({
  "card": "-e6Giq_card",
  "location": "-e6Giq_location",
  "percentage": "-e6Giq_percentage",
  "producer-location-container": "-e6Giq_producer-location-container",
});
